import React, { createContext, useState } from 'react';
import { useDialogStore } from 'hooks/dialogStore/useDialogStore';
import { LEGACY_DIALOG_KEYS } from 'modals/keys';
import {
  ContextPortalID,
  useContextPortal,
} from '../../Router/pages/TourEditPage/hooks/useContextPortal';

import ListingSummaryProps from '../../types/listingSummaryPropsType';

export type AddListingToTourModalContextType = {
  modalVisible: boolean;
  setModalVisible: (visible: boolean) => void;
  listing: ListingSummaryProps;
  setListing: React.Dispatch<React.SetStateAction<ListingSummaryProps>>;
};

export const AddListingToTourModalContext =
  createContext<AddListingToTourModalContextType>(null);

export const AddListingToTourModalContextProvider: React.FC = ({
  children,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [listing, setListing] = useState(null);
  const ContextPortal = useContextPortal(
    ContextPortalID.ADD_LISTING_TO_TOUR_CONTEXT,
  );

  const { addDialog, removeDialog, isDialogVisible, isUsingNewArchitecture } =
    useDialogStore();
  const usingNewModalArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.AddListingToTourModal,
  );

  const onSetModalVisible = (visible: boolean) => {
    if (!usingNewModalArch) {
      setModalVisible(visible);
      return;
    }

    if (visible) {
      addDialog({ key: LEGACY_DIALOG_KEYS.AddListingToTourModal });
      return;
    }

    removeDialog(LEGACY_DIALOG_KEYS.AddListingToTourModal);
  };

  return (
    <AddListingToTourModalContext.Provider
      value={{
        modalVisible: usingNewModalArch
          ? isDialogVisible(LEGACY_DIALOG_KEYS.AddListingToTourModal)
          : modalVisible,
        setModalVisible: onSetModalVisible,
        listing,
        setListing,
      }}
    >
      <ContextPortal />
      {children}
    </AddListingToTourModalContext.Provider>
  );
};

export default AddListingToTourModalContext;
